<template><div><h1 id="mailserver-domain-stammtabelle" tabindex="-1"><a class="header-anchor" href="#mailserver-domain-stammtabelle"><span>Mailserver-Domain Stammtabelle</span></a></h1>
<p>Mailserver-Domain Stammtabelle — Verwaltet die Mailserver-Domains</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In dieser Tabelle werden Mailserver-Domains definiert. Beim erfassen von E-Mail Adressen in den Telekommunikationsdaten, werden die Einträge mit dieser Tabelle validiert. Die Tabelle wird automatisch mit den Domains der laufend erfassten E-Mail Adressen erweitert. Die Domains können auf ihre Gültigkeit aktualisiert werden. Siehe <RouteLink to="/referenz/refs/ft.refproc.maildom.html" title="Mailserver-Domains aktualisieren">Mailserver-Domains aktualisieren</RouteLink></p>
<p>Pfad: <code v-pre>Personen → Tabellen → Telekommunikation → Mailserver Domain Names</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Mailserver-Domain</dt>
<dd>Domainname des Mailservers (z.B bluewin.ch)</dd>
<dt>gültig</dt>
<dd>Gültigkeit der Domain, ja/nein</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>N/A</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refproc.maildom.html" title="Mailserver-Domains aktualisieren">Mailserver-Domains aktualisieren</RouteLink></p>
</div></template>


